import { ref } from 'vue';

// Create a shared ref that can be imported by multiple components
const refreshTrigger = ref(0);

export function usePinnedListRefresh() {
    const triggerRefresh = () => {
        refreshTrigger.value++;
    };

    return {
        refreshTrigger,
        triggerRefresh,
    };
}
